import { number, object, setLocale, string } from 'yup'

import { stringify } from 'src/core/hooks/use-translation'

setLocale({
  mixed: {
    default: 'common.required',
    required: 'common.required',
    notType: 'common.required'
  }
})

export default object().shape({
  organization_id: number().positive().required(),
  policy_rule_id: number().positive().required(),
  description: string()
    .max(
      250,
      stringify('web.setup.form.field-title.max-character-error', {
        value: 250
      })
    )
    .required()
})
